package com.vectencia.klarinet

actual enum class AudioSessionMode {
    DEFAULT, MEASUREMENT, VOICE_CHAT, GAME_CHAT
}
